import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UuidOptionColor, TypeChartData } from '@/domain/services/Clas';

type CustomLegendProps = {
  data: TypeChartData[];
  labels: UuidOptionColor[];
  columnWidth?: number;
  columns?: number;
}

const CustomLegend: FC<CustomLegendProps> = ({ data, labels, columnWidth = 150, columns = 4 }) => {
  // Ordenamos los datos como en el gráfico y eliminamos los que no tienen valor
  const sortedData = data
    .map(d => ({
      ...d,
      name: labels.find(l => l.uuid === d.uuid)?.name || d.uuid,
      color: labels.find(l => l.uuid === d.uuid)?.color || '#ccc'
    }))
    .sort((a, b) => b.totalAreaInHa - a.totalAreaInHa)
    .filter(item => item.totalAreaInHa !== 0);

  // Dividimos en columnas
  const perColumn = Math.ceil(sortedData.length / columns);
  const columnsData = Array.from({ length: columns }, (_, i) =>
    sortedData.slice(i * perColumn, (i + 1) * perColumn)
  );

  return <Box display="flex" gap={2} sx={{mb: 1}}>
    {columnsData.map((column, i) => (
      <Box key={i} display="flex" flexDirection="column" sx={{ width: columnWidth}}>
        {column.map(data => (
          <Box key={data.uuid} display="flex" alignItems="center">
            <Box
              sx={{
                width: 12,
                height: 12,
                backgroundColor: data.color,
                borderRadius: '50%',
                mr: 1.5
              }}
            />
            <Typography sx={{fontSize: '12px'}}>{data.name}
              <Typography component='span' sx={{ml: 1, fontSize: '12px', color: 'grey.500'}}>{`(${data.totalAreaInHa} Ha)`}</Typography>
            </Typography>
          </Box>
        ))}
      </Box>
    ))}
  </Box>;
};

export default CustomLegend;